import { Flex, Modal } from "antd"

import { content } from "./content"
import css from "./index.module.css"

type Props = {
  contentKey: string
  onClose: () => void
  open: boolean
}
// @ts-ignore
import React, { useEffect, useState } from "react"
import { Document, Page } from "react-pdf"
import { computed } from "mobx"
import { observer } from "mobx-react"

// @ts-ignore
import termsPdf from "@src/app/assets/pdf/cryptix_terms.pdf"
// @ts-ignore
import privacyPolicyTransferPdf from "@src/app/assets/pdf/PP_Transferio.pdf"
// @ts-ignore
import privacyPolicyPdf from "@src/app/assets/pdf/privacy_policy.pdf"
// @ts-ignore
import termsTransferPdf from "@src/app/assets/pdf/T&C_Transferio.pdf"
// @ts-ignore
import referralTerms from "@src/app/assets/pdf/terms_and_conditions_cryptix_referral.pdf"
import uiStore from "@src/app/uiStore"

export const ModalInfo = observer(({ contentKey, onClose, open }: Props) => {
  const { isTransferioTheme } = uiStore()
  const [numPages, setNumPages] = useState<number>()
  const [pageNumber, setPageNumber] = useState<number>(1)

  function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
    setNumPages(numPages)
  }

  const pdfMap: Record<string, string> = computed(() => {
    return {
      merchant: isTransferioTheme ? termsTransferPdf : termsPdf,
      policy: isTransferioTheme ? privacyPolicyTransferPdf : privacyPolicyPdf,
      referrer: referralTerms,
    }
  }).get()

  return (
    <Modal
      className={css.modal}
      footer={null}
      onCancel={onClose}
      open={open}
      width={900}
    >
      <Flex justify="center" style={{ width: "100%" }}>
        <Document
          file={pdfMap[contentKey]}
          onLoadSuccess={onDocumentLoadSuccess}
          scale={1.5}
        >
          {Array.from(new Array(numPages), (_, index) => (
            <Page
              key={index}
              pageNumber={index + 1}
              renderAnnotationLayer={false}
              renderTextLayer={false}
            ></Page>
          ))}
        </Document>
      </Flex>
    </Modal>
  )
})
